export function flattenMatchOdds(match) {
  if (!match) return match;
  const odd = match.odd || {};
  return {
    ...match,
    handicapOdds: match.handicapOdds || odd.handicapOdds,
    overUnderOdds: match.overUnderOdds || odd.overUnderOdds,
    europeOdds: match.europeOdds || odd.europeOdds,
    handicapHalfOdds: match.handicapHalfOdds || odd.handicapHalfOdds,
    overUnderHalfOdds: match.overUnderHalfOdds || odd.overUnderHalfOdds,
    europeHalfOdds: match.europeHalfOdds || odd.europeHalfOdds,
  };
}
